export default __webpack_public_path__ + "static/p6-1d8a4473eab0b16e81e60b8ea654177f.png";